import { render, staticRenderFns } from "./TransactionsTable.vue?vue&type=template&id=7ba7ab1e&"
import script from "./TransactionsTable.vue?vue&type=script&lang=ts&"
export * from "./TransactionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports